import { actions as reduxActions } from '../reducers';
import { getData } from '../../../utils/http';
import { OUTSIDE_API } from '../../../consts/endpoints';
import { isDefined } from '../../../utils/isDefined';
import Optional from '../../../utils/optional';
import { translate } from '../../../i18n/I18nProvider';
import {
  mapDatacards,
  mapStandardCards,
  mapUser,
  splitSimCards
} from './getUserHelpers';

const getUser = ({ connectClientId, user, clientId }) => {
  const licenseTypes = {
    UC: translate('USER.LICENSE_UC'),
    LU: translate('USER.LIGHT_USER'),
    BL: translate('USER.BASIC_USER')
  };

  const { username, licenseType, simCards = [] } = user;

  return async dispatch => {
    const { datacards, standardCards } = splitSimCards(simCards);
    let user = {
      licenseType: Optional(licenseTypes[licenseType]).or(licenseType),
      datacards,
      standardCards
    };

    let error = {};
    let values = {};

    try {
      const response = await getData(
        `${OUTSIDE_API.CLIENTS}/${connectClientId}/users/${username}`
      );

      if (isDefined(response)) {
        const mappedUser = mapUser(response);
        user = { ...user, ...mappedUser };
      }

      if (standardCards.length > 0) {
        const result = await mapStandardCards(standardCards, clientId);
        user = { ...user, standardCardsWithSub: result.cards };
        values = { ...values, ...result.values };
        error = { ...error, ...result.error };
      }
      if (datacards.length > 0) {
        const result = await mapDatacards(datacards, clientId);
        user = { ...user, datacardsCardsWithSub: result.cards };
        values = { ...values, ...result.values };
        error = { ...error, ...result.error };
      }
    } catch (e) {
      error = { ...error, requestError: true };
    } finally {
      dispatch(
        reduxActions.openTerminateUser({
          user,
          error,
          values
        })
      );
    }
  };
};

export default getUser;
